<template>
  <div>
    <header class="main-header">
      <h1>Vector Image Editor</h1>
      <div class="import-export-buttons">
        <!-- ButtonWithOptions for export functionality -->
        <div class="button-with-options">
          <button @click="toggleExportOptions">
            <span class="mdi mdi-download"></span> Export as…
          </button>
          <ul v-if="showExportOptions">
            <li @click="saveCanvas('png')"><span class="mdi mdi-file-image"></span> PNG</li>
            <li @click="saveCanvas('svg')"><span class="mdi mdi-vector-square"></span> SVG</li>
            <li @click="saveCanvas('json')"><span class="mdi mdi-code-braces"></span> JSON</li>
          </ul>
        </div>
        <!-- ImportButton for importing images -->
        <div class="import-button">
          <input type="file" @change="handleFileSelection" accept="image/*" hidden id="fileInput">
          <label for="fileInput">Import</label>
        </div>
        <!-- <button @click="submitImport">Submit</button> -->
      </div>
    </header>
    <div v-if="imageEditorOpen" class="image-editor-container">
      <!-- Container for the canvas or image display -->
      <div v-if="generatedImageUrl" class="image-container">
        <img :src="generatedImageUrl" alt="Generated Image" />
      </div>
      <!-- <canvas id="canvas" width="1600" height="1000"></canvas>
      <div class="editor-buttons">
        <v-btn @click="setActiveTool('select')">Select</v-btn>
        <v-btn @click="setActiveTool('move')">Move</v-btn>
        <v-btn @click="setActiveTool('scale')">Scale</v-btn>  
        <v-btn @click="toggleDrawingMode">Draw</v-btn>
        <v-btn @click="addLayer">Add Layer</v-btn>
      </div> -->
    </div>
    <div>
      <h3>Saved Vector</h3>
      <ul>
        <li v-for="(image, index) in savedImages" :key="index" class="image-item">
          <img :src="image.url" alt="Saved Image" class="saved-image"/>
          <div>{{ image.name }}</div>
          <button @click="editImage(index)">Edit</button>
          <button @click="deleteImage(index)">Delete</button>
          <button @click="downloadImage(index)">Download</button>
          <button @click="toggleExportOptions">
        <span class="mdi mdi-download"></span> Export as…
      </button>
      <ul v-if="showExportOptions">
        <li @click="saveCanvas('png')"><span class="mdi mdi-file-image"></span> PNG</li>
        <li @click="saveCanvas('svg')"><span class="mdi mdi-vector-square"></span> SVG</li>
        <li @click="saveCanvas('json')"><span class="mdi mdi-code-braces"></span> JSON</li>
      </ul>
        </li>
      </ul>
    </div>
  </div>
</template>


<script>
import { fabric } from 'fabric';

export default {
  data() {
    return {
      imageEditorOpen: false,
      canvas: null,
      selectedFile: null,
      savedImages: [],
      showExportOptions: false,
      isDrawingMode: false,
      activeTool: '', // Keep track of the active tool
      activeImage: null,
      generatedImageUrl: null,
    };
  },
  mounted() {
    this.initializeCanvas();
  },
  methods: {
    initializeCanvas() {
      this.canvas = new fabric.Canvas('canvas', {
        selection: true,
        preserveObjectStacking: true,
      });
      this.canvas.setWidth(1200);
      this.canvas.setHeight(800);
    },
    setActiveTool(tool) {
      this.activeTool = tool;
      switch(tool) {
        case 'select':
          this.canvas.isDrawingMode = false;
          this.canvas.selection = true; // Enable selection
          break;
        case 'draw':
          this.canvas.isDrawingMode = true;
          this.canvas.freeDrawingBrush.width = 5;
          this.canvas.freeDrawingBrush.color = '#ff0000';
          break;
        case 'move':
          // Moving is handled by Fabric.js natively; you might want to implement custom logic here
          break;
        case 'scale':
          // Scaling is handled by Fabric.js natively; you might want to implement custom logic here
          break;
        // Implement other cases as needed
        default:
          console.log(`Tool ${tool} is not yet implemented.`);
      }
    },
    addLayer() {
      // Example: Adding a simple rectangle as a new layer
      const rect = new fabric.Rect({
        left: 100,
        top: 100,
        fill: 'lightblue',
        width: 100,
        height: 100
      });
      this.canvas.add(rect);
      this.canvas.renderAll();
    },
    toggleDrawingMode() {
      this.isDrawingMode = !this.isDrawingMode;
      this.canvas.isDrawingMode = this.isDrawingMode;
    },
    toggleExportOptions() {
      this.showExportOptions = !this.showExportOptions;
    },
    handleFileSelection(event) {
      this.selectedFile = event.target.files[0];
      this.submitImport();
    },
    saveCanvas(format) {
  if (!this.canvas) {
    alert("Canvas is not initialized.");
    return;
  }

  let dataUrl;
  switch (format) {
    case 'png': {
      dataUrl = this.canvas.toDataURL('image/png');
      break;
    }
    case 'svg': {
      const svgData = this.canvas.toSVG();
      const svgBlob = new Blob([svgData], { type: 'image/svg+xml' });
      dataUrl = URL.createObjectURL(svgBlob);
      break;
    }
    case 'json': {
      const jsonExport = this.canvas.toJSON();
      dataUrl = `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(jsonExport))}`;
      break;
    }
    default: {
      console.error("Unsupported format");
      return;
    }
  }

  const link = document.createElement('a');
  link.download = `canvas-export.${format}`;
  link.href = dataUrl;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
},


displayImage(dataUrl) {
    fabric.Image.fromURL(dataUrl, (img) => {
      this.canvas.clear();
      this.canvas.add(img);
      this.canvas.centerObject(img);
      this.canvas.renderAll();

      // Update activeImage with the new image details
      this.activeImage = {
        image: img, // This is a Fabric object; consider what properties you need
        name: 'Loaded Image', // You might dynamically generate or get this name
        url: dataUrl,
        object: img, // This is a Fabric object; consider what properties you need
      };
    });
  },

// submitImport() {
//   if (!this.selectedFile) {
//     alert("Please select a file first.");
//     return;
//   }

//   const reader = new FileReader();

//   // Here, 'e' is used, so the error should not refer to this part
//   reader.onload = (event) => { // Changed 'e' to 'event' for clarity
//     const dataUrl = event.target.result;
    
//     fabric.Image.fromURL(dataUrl, (img) => {
//       img.set({
//         left: 0,
//         top: 0,
//         angle: 0,
//         cornerSize: 15,
//         transparentCorners: false,
//       });
      
//       this.canvas.clear();
//       this.canvas.add(img);
//       this.canvas.centerObject(img);
//       this.imageEditorOpen = true; // Ensure the editor is marked as open
//       this.canvas.renderAll();

//        // Temporarily save the image for editing without pushing it to `savedImages`
//        this.activeImage = { object: img, url: dataUrl };

//       // Add the image to savedImages for later editing, deleting, or downloading
//       this.savedImages.push({
//         name: `Imported_${new Date().getTime()}`,
//         url: dataUrl, // For download functionality
//         object: img, // For editing functionality
//       });
//     });
//   };

//   reader.readAsDataURL(this.selectedFile);
// },
submitImport() {
      // Import the selected file and add it to the canvas
      if (!this.selectedFile) {
        alert("Please select a file first.");
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        const dataUrl = event.target.result;
        this.generatedImageUrl = dataUrl; // Set the image URL for potential non-canvas use
        fabric.Image.fromURL(dataUrl, (img) => {
          // Scale image to fit the canvas if necessary
          const scale = Math.min(this.       canvas.width / img.width, this.canvas.height / img.height);
          img.set({
            scaleX: scale,
            scaleY: scale,
            originX: 'left',
            originY: 'top'
          });
          this.canvas.clear();
          this.canvas.add(img);
          this.canvas.centerObject(img);
          this.canvas.renderAll();

          // Store the image details in activeImage
          this.activeImage = {
            image: img,
            name: 'Imported Image',
            url: dataUrl,
          };

          // Optionally, add the image to savedImages for later use
          this.savedImages.push({
            name: `Imported_${new Date().getTime()}`,
            url: dataUrl,
            object: img,
          });

          this.imageEditorOpen = true; // Open the editor with the canvas
        });
      };
      reader.readAsDataURL(this.selectedFile);
    },
    setTool(tool) {
      this.activeTool = tool;
      // Deactivate all tools and activate the selected one
      switch(tool) {
        case 'select':
          this.canvas.isDrawingMode = false;
          // Implement additional tool activation logic if needed
          break;
        case 'draw':
          this.canvas.isDrawingMode = true;
          this.canvas.freeDrawingBrush.width = 5;
          this.canvas.freeDrawingBrush.color = '#ff0000';
          break;
        // Add cases for other tools like 'scale', 'move', etc.
        default:
          console.log(`Tool ${tool} is not implemented.`);
      }
    },
  downloadCanvasContent() {
    // Assuming you want to download the canvas as a PNG image
    const format = 'png'; // You can make this dynamic based on user input if needed
    const dataUrl = this.canvas.toDataURL({format: format});

    const link = document.createElement('a');
    link.download = `canvas-export.${format}`;
    link.href = dataUrl;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  },
  addRectangle() {
      const rect = new fabric.Rect({
        left: 50,
        top: 50,
        fill: 'red',
        width: 60,
        height: 70,
        angle: 0,
      });
      this.canvas.add(rect).setActiveObject(rect);
    },
    addCircle() {
      const circle = new fabric.Circle({
        radius: 30,
        fill: 'green',
        left: 100,
        top: 100,
      });
      this.canvas.add(circle).setActiveObject(circle);
    },
    addText() {
      const text = new fabric.IText('Hello world', {
        left: 200,
        top: 200,
        fontFamily: 'Arial',
        fill: '#333',
        fontSize: 20,
      });
      this.canvas.add(text).setActiveObject(text);
    },
    saveEditedImage() {
      const imageDataUrl = this.canvas.toDataURL();
      const imageJson = JSON.stringify(this.canvas.toJSON());
      const newImage = {
        name: `EditedImage_${new Date().getTime()}`,
        url: imageDataUrl,
        json: imageJson,
      };
      this.savedImages.push(newImage);
    },
editImage(index) {
  const imageObject = this.savedImages[index].object;
  if (imageObject) {
    // Assuming 'object' is a reference to the Fabric.js object
    this.canvas.setActiveObject(imageObject);
    // Further editing actions would depend on your application's UI/UX
  }
},
deleteImage(index) {
  if (confirm("Are you sure you want to delete this image?")) {
    this.savedImages.splice(index, 1);
    // Additional cleanup after deletion, if necessary
  }
},
downloadImage(index) {
  const imageToDownload = this.savedImages[index];
  // Assuming `imageToDownload` has a property `url` that points to the image's location
  // and a `name` property for the filename
  const link = document.createElement('a');
  link.href = imageToDownload.url;
  link.download = imageToDownload.name || 'downloaded-image'; // Default name if none provided
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
},
closeImageEditor() {
      this.imageEditorOpen = false;
      this.canvas.clear();
    },
  },
};
</script>

<style scoped>

.button-with-options button,
.editor-btn,
.import-button label {
  background-color: #42b983; /* A nice green shade */
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.button-with-options button:hover,
.editor-btn:hover,
.import-button label:hover {
  background-color: #333; /* Darken button on hover for feedback */
}

.options-list {
  list-style-type: none;
  padding: 0;
  margin: 10px 0 0;
  position: absolute;
  background-color: #fff;
  border: 1px solid #ccc;
  z-index: 100;
}

.options-list li {
  padding: 10px;
  cursor: pointer;
}

.options-list li:hover {
  background-color: #f0f0f0;
}

.import-button label {
  display: inline-block;
}


/* Adjust the canvas container size as needed */
.canvas-container {
  width: 800px;
  height: 600px;
  margin: auto;
  position: relative;
}
.main-header {
  text-align: center;
  margin: 20px 0;
}

.import-button {
  background-color: #42b983;
  color: white;
  padding: 10px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.editor-buttons button {
  margin: 5px;
}

#canvas {
  border: 1px solid #ccc;
  margin-top: 20px;
  width: 100%;
  border-radius: 5px;
  
}

.image-editor-container {
  border: 1px solid #ccc;
  margin-top: 20px;
  width: 100%;
  border-radius: 5px;
    height: 100%;
    padding: 20%; /* Adjust padding for smaller screens */
    text-align: center;
}

@media (max-width: 900px) {
  .canvas-container,
  .image-editor-container {
    width: 100%;
    height: auto;
    padding: 20px; /* Adjust padding for smaller screens */
  }
}

</style>
